'use strict';

const React = require('react');
const PropTypes = require('prop-types');
const ContextComponent = require('../../../global/components/ContextComponent');
const DetailsItems = require('../../details/components/DetailsItems');
const findNameSpace = require('find-namespace-value');
const provideContext = require('fluxible-addons-react/provideContext');
const connectToStores = require('fluxible-addons-react/connectToStores');
const ItemStore = require('../../stores/ItemStore.es');

class Details extends ContextComponent {
    constructor(props) {
        super(props);

        this.mainTitle = findNameSpace('details.mainTitle', props.copy);
    }

    render() {
        const props = this.props;

        return (
            <div className="pdp-details-subcontainer rowFlexTransition">
                <div className="pdp-details-title-container colXs12">
                    <h2 className="pdp-details-title header-primary-large pdp-secondary-header">{this.mainTitle}</h2>
                </div>
                <DetailsItems detailsConfig={props.detailsConfig} details={props.details} detailsTitles={props.detailsTitles} isPrintPage={props.isPrintPage} />
            </div>
        );
    }
}

Details.defaultProps = {
    isPrintPage: false
};

Details.propTypes = {
    detailsConfig: PropTypes.array.isRequired,
    details: PropTypes.object.isRequired,
    detailsTitles: PropTypes.object.isRequired,
    vertical: PropTypes.string.isRequired,
    copy: PropTypes.object.isRequired,
    isPrintPage: PropTypes.bool
};

const Connected = provideContext(connectToStores(
    Details,
    [
        ItemStore
    ],
    context => {
        const itemStore = context.getStore(ItemStore);
        return ({
            copy: itemStore.getCopy(),
            detailsTitles: itemStore.getDetailsTitles(),
            details: itemStore.getDetails(),
            detailsConfig: itemStore.getDetailsConfig(),
            vertical: itemStore.getFromItemModel('vertical')
        });
    }
));

module.exports = {
    Connected,
    Raw: Details
};



// WEBPACK FOOTER //
// ./assets/js/newPdp/components/Details/Details.jsx